module.exports = __webpack_public_path__ + "img/project-2.dd86bf08.jpg";